import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import {
  API_ENDPOINTS,
  PRISM_API_BASE_URL,
} from "../../shared/constants/constants";

export const getPOList = createAsyncThunk(
  "getOrderList",
  async (parameter: any) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getOrderList;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getOrderDetails = createAsyncThunk(
  "getOrderDetails",
  async (id: any, { dispatch }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getOrder}/${id}`;
    // console.log("url :: " + url);
    try {
      const response = await axiosGet(url);
      let orderStatusHistory;
      let partyVendorContactDetails;
      if (response.status === 200) {
        orderStatusHistory = await dispatch(getOrderStatusHistory(id)).unwrap();
        partyVendorContactDetails = await dispatch(
          getPartyContactDetails(response.data?.order?.fulfilledByPartyId?._id)
        ).unwrap();
      }

      return {
        data: {
          ...response.data,
          quoteData: orderStatusHistory.data,
          partyVendorContactDetails: partyVendorContactDetails.data,
        },
        status: response.status,
      };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getOrderStatusHistory = createAsyncThunk(
  "getOrderStatusHistory",
  async (id: any) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getOrder}/${id}/statuses`;

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getPartyContactDetails = createAsyncThunk(
  "getPartyContactDetails",
  async (id: any) => {
    const { axiosGet } = useCustomAxios();
    let url = `${PRISM_API_BASE_URL}/party/${id}/contactmechs`;

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const updateOrderContactMech = createAsyncThunk(
  "updateOrderContactMech",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updateOrderContactMech}`;
    url = url.replace("ORDER_ID", reqBody.orderId);

    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const generateOrder = createAsyncThunk(
  "createOrder",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.createOrder}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const createOrderStandaloneApi = createAsyncThunk(
  "createOrderStandaloneApi",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.createOrderStandalone}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "updateOrder",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updateOrderStatus}`;
    url = url.replace(":orderId", reqBody?.orderId);
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const getOrderPdf = createAsyncThunk(
  "buyer/getOrderPdf",
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.downloadOrderPdf;

    try {
      const response = await axiosPost(`${url}`, reqBody);
      const downloadURL = response.data.downloadURL;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = downloadURL;
      downloadLink.download = "order.pdf";
      downloadLink.target = "_blank";
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const updateOrderItem = createAsyncThunk(
  "cancelOrderItem",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updateOrderItem}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deliverOrder = createAsyncThunk(
  "deliverOrder",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.deliverOrderApi}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const generateThreeWay = createAsyncThunk(
  "generateThreeWay",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.generateThreeWayComparison}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const generateInvoiceFromAccounts = createAsyncThunk(
  "generateInvoiceFromAccounts",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.generateInvoiceFromAccounts}`;
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getOrderRemainingItemsPdf = createAsyncThunk(
  "getOrderRemainingItemsPDF",
  async (orderId: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getRemainingOrderItems.replace(":orderId", orderId);
    try {
      const response = await axiosGet(url, {
        responseType: 'blob',
      });
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPOStatusDashboard = createAsyncThunk(
  "getPOStatusDashboard",
  async (parameter: any, {rejectWithValue}) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getOrderStatusDashboard;
    // let url = API_ENDPOINTS.getOrderList;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);